import { triggerGamificationRule } from "../../utils/fw"


const between = (start, end) => new Date() > new Date(start) && new Date() < new Date(end)
const changeMeeting = (id, password) => {
	document.getElementById("engagement-sessions-screen").src = `https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=${password}&meetingNumber=${id}`
}

export default {
	background: "https://assets.swoogo.com/uploads/full/5403549-6838c7d691cb8.jpg",
	extras: (
		<>
			<iframe allowfullscreen frameborder="0" id="engagement-sessions-screen"
				style={{
					width: "calc(65.6% * 1.33333)",
					height: "calc(74.6% * 1.33333)",
					left: "17.1%",
					top: ".8%",
					position: "absolute",
					cursor: "pointer",
					display: "block",
					zIndex: "5",
					overflow: "hidden",
					transformOrigin: "top left",
					transform: "scale(0.75)",
				}}
				src=""
			/>
		</>
	),
	links: [
		{
			height: "7.7%",
			href: "https://isfcongress.tkeventsregistration.com/digital2021/engagementschedule",
			label: "Agenda",
			left: "0.5%",
			top: "3.3%",
			width: "16.1%",
		},
		{
			height: "10.3%",
			label: "4.5 Supply Chain Security: Interactive Training Workshop - Part 1",
			left: "0.5%",
			top: "19.7%",
			width: "16.1%",
			onClick: () => {
				if (between("2021-10-25 14:00+01:00", "2021-10-25 16:30+01:00")) {
					changeMeeting("86591732561", "188141")
					triggerGamificationRule("ES 4.5 1")
				}
				else if (between("2021-10-26 06:00+01:00", "2021-10-26 08:30+01:00")) {
					changeMeeting("81236513169", "914529")
					triggerGamificationRule("ES 4.5 2")
				}
			},
		},
		{
			height: "10.3%",
			label: "9.5 Supply Chain Security: Interactive Training Workshop - Part 2",
			left: "0.5%",
			top: "31.8%",
			width: "16.1%",
			onClick: () => {
				if (between("2021-10-26 14:00+01:00", "2021-10-26 16:30+01:00")) {
					changeMeeting("89409383680", "653452")
					triggerGamificationRule("ES 9.5 1")
				}
				else if (between("2021-10-27 06:00+01:00", "2021-10-27 08:30+01:00")) {
					changeMeeting("81991487965", "018616")
					triggerGamificationRule("ES 9.5 2")
				}
			},
		},
		{
			height: "10.3%",
			label: "5.3 & 8.5 Translating Risk: An ISF Learning Espresso Session",
			left: "0.5%",
			top: "43.9%",
			width: "16.1%",
			onClick: () => {
				if (between("2021-10-25 15:00+01:00", "2021-10-25 17:30+01:00")) {
					changeMeeting("82061301867", "472125")
					triggerGamificationRule("ES 5.3 1")
				}
				else if (between("2021-10-26 07:00+01:00", "2021-10-26 09:30+01:00")) {
					changeMeeting("89742854311", "922210")
					triggerGamificationRule("ES 5.3 2")
				}
				else if (between("2021-10-26 21:00+01:00", "2021-10-26 23:30+01:00")) {
					changeMeeting("88328486331", "677313")
					triggerGamificationRule("ES 8.5 1")
				}
			},
		},
		{
			height: "10.3%",
			label: "4.6 & 5.5 Threat Horizon 2024 Workshop",
			left: "0.5%",
			top: "56%",
			width: "16.1%",
			onClick: () => {
				if (between("2021-10-25 15:00+01:00", "2021-10-25 17:30+01:00")) {
					changeMeeting("83390804059", "008047")
					triggerGamificationRule("ES 5.5 1")
				}
				else if (between("2021-10-26 06:00+01:00", "2021-10-26 08:30+01:00")) {
					changeMeeting("81729040993", "615981")
					triggerGamificationRule("ES 4.6 1")
				}
			},
		},
		{
			gameRule: "feedback-engagement",
			gameRuleCooldown: 1000 * 60 * 60,
			height: "8%",
			href: "https://isfcongress.tkeventsregistration.com/ffengagement",
			isExternal: true,
			label: "Feedback",
			left: "83.3%",
			target: "_blank",
			top: "3%",
			width: "16%",
		},
		{
			height: "9.8%",
			label: "8.5 & 11.5 Surviving An Extinction Level Attack Workshop",
			left: "83.5%",
			top: "19.7%",
			width: "15.9%",
			onClick: () => {
				if (between("2021-10-26 11:00+01:00", "2021-10-26 13:30+01:00")) {
					changeMeeting("82545079154", "264387")
					triggerGamificationRule("ES 8.5 2")
				}
				else if (between("2021-10-27 08:00+01:00", "2021-10-27 10:30+01:00")) {
					changeMeeting("85757976353", "559110")
					triggerGamificationRule("ES 11.5 1")
				}
				else if (between("2021-10-27 17:00+01:00", "2021-10-27 19:30+01:00")) {
					changeMeeting("89536735958", "835434")
					triggerGamificationRule("ES 11.5 2")
				}
			},
		},
		{
			height: "9.8%",
			label: "9.3 ISF Standard of Good Practice: Exploring The New SOGP WebApp",
			left: "83.5%",
			top: "31.8%",
			width: "15.9%",
			onClick: () => {
				if (between("2021-10-26 14:00+01:00", "2021-10-26 16:00+01:00")) {
					changeMeeting("85738919613", "530429")
					triggerGamificationRule("ES 9.3 1")
				}
				else if (between("2021-10-26 22:00+01:00", "2021-10-27 00:00+01:00")) {
					changeMeeting("85738919613", "530429")
					triggerGamificationRule("ES 9.3 1")
				}
				else if (between("2021-10-27 06:00+01:00", "2021-10-27 08:00+01:00")) {
					changeMeeting("85738919613", "530429")
					triggerGamificationRule("ES 9.3 1")
				}
			},
		},
		{
			height: "9.8%",
			label: "13.5 Backdoors and Breaches: Cyber Security Exercise",
			left: "83.5%",
			top: "44%",
			width: "15.9%",
			onClick: () => {
				if (between("2021-10-27 10:00+01:00", "2021-10-27 12:00+01:00")) {
					changeMeeting("83464749474", "646515")
					triggerGamificationRule("ES 13.5 1")
				}
				else if (between("2021-10-27 20:00+01:00", "2021-10-27 22:00+01:00")) {
					changeMeeting("86086468088", "131142")
					triggerGamificationRule("ES 13.5 1")
				}
			},
		},
		{
			height: "9.8%",
			label: "14.4 Information Security In Mergers and Acquisitions",
			left: "83.5%",
			top: "56.4%",
			width: "15.9%",
			onClick: () => {
				if (between("2021-10-27 13:00+01:00", "2021-10-27 15:00+01:00")) {
					changeMeeting("81178955118", "600471")
					triggerGamificationRule("ES 14.4 1")
				}
				else if (between("2021-10-27 21:00+01:00", "2021-10-27 23:00+01:00")) {
					changeMeeting("81178955118", "600471")
					triggerGamificationRule("ES 14.4 1")
				}
				else if (between("2021-10-28 05:00+01:00", "2021-10-28 07:00+01:00")) {
					changeMeeting("81178955118", "600471")
					triggerGamificationRule("ES 14.4 1")
				}
			},
		},
	],
	name: "engagement-sessions",
}
